import { Switch } from "react-router";
import ProtectedRoute from "../../hoc/ProtectedRoute/ProtectedRoute";
import AboutPage from "../../pages/AboutPage/AboutPage";
import Dashboard from "../../pages/Dashboard/Dashboard";
import DeviceDetail from "../../pages/Device/DeviceDetail/DeviceDetail";
import DeviceList from "../../pages/Device/DeviceList/DeviceList";
import FaqPage from "../../pages/FaqPage/FaqPage";
import MessageList from "../../pages/Message/MessageList/MessageList";
import NotFound from "../../pages/NotFound/NotFound";
import PatientDetail from "../../pages/Patient/PatientDetail/PatientDetail";
import PatientList from "../../pages/Patient/PatientList/PatientList";
import PatientReport from "../../pages/Patient/PatientReport/PatientReport";
import PatientReportComparison from "../../pages/Patient/PatientReportComparison/PatientReportComparison";
import PatientReportStatistic from "../../pages/Patient/PatientReportStatistic/PatientReportStatistic";
import Profile from "../../pages/Profile/Profile";
import RecordDetail from "../../pages/Record/RecordDetail/RecordDetail";
import RecordList from "../../pages/Record/RecordList/RecordList";
import DashboardTemplate from "../../templates/DashboardTemplate/DashboardTemplate";
import Print from "../../pages/Print/Print";

const DashboardRouter = (props) => {
  return (
    <DashboardTemplate>
      <Switch>
        
        <ProtectedRoute
          path="/patient/:id/statistic"
          component={PatientReportStatistic}
        />
        <ProtectedRoute
          path="/patient/:id/record-comparison"
          component={PatientReportComparison}
        />
        <ProtectedRoute
          path="/patient/:id/:recordId"
          component={PatientReport}
        />
        <ProtectedRoute path="/patient/:id" component={PatientDetail} />
        <ProtectedRoute path="/patient" component={PatientList} />
        <ProtectedRoute path="/message" component={MessageList} />
        <ProtectedRoute path="/profile/" component={Profile} />
        <ProtectedRoute path="/device/:id" component={DeviceDetail} />
        <ProtectedRoute path="/device/" component={DeviceList} />
        <ProtectedRoute path="/record/:id" component={RecordDetail} />
        <ProtectedRoute path="/record/" component={RecordList} />
        <ProtectedRoute path="/faq/" component={FaqPage} />
        <ProtectedRoute path="/about/" component={AboutPage} />
        <ProtectedRoute exact path="/" component={Dashboard} />
        <ProtectedRoute component={NotFound} />
      </Switch>
    </DashboardTemplate>
  );
};

export default DashboardRouter;
